import { Font, StyleSheet, Text, View } from '@react-pdf/renderer';

import { PublicEventDetailsResponse } from '@hubs101/booking-api-skd-client/lib/types';
import { globalStyles } from '../../styles';
import { styles } from './styles';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

Font.register({
  family: 'FontAwesome',
  src: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.4/webfonts/fa-solid-900.ttf',
});
interface EventAtGlanceProps {
  event: PublicEventDetailsResponse;
}

export const stylesAwesome = StyleSheet.create({
  icon: {
    fontFamily: 'FontAwesome',
    fontSize: 32,
  },
  whiteIcon: {
    fontFamily: 'FontAwesome',
    fontSize: 30,
    color: 'white',
    padding: '13 10',
    backgroundColor: 'black',
    borderRadius: '50%',
    transform: 'scale(1.1)',
  },
});

const EventAtGlance = ({ event }: EventAtGlanceProps) => {
  const { t } = useTranslation();

  const eventStatisticsItems = useMemo(
    () =>
      event?.website_content?.whoattend
        ?.filter(e => e)
        ?.sort((a, b) => a.order - b.order)
        ?.map(whoAttend => ({
          description: whoAttend?.description,
          title: whoAttend?.value,
          icon: whoAttend?.icon?.split('-')?.join('_'),
        })),
    [event?.website_content?.whoattend]
  );

  return (
    <View style={globalStyles.body}>
      <Text style={globalStyles.title}>{event?.name}</Text>
      <Text
        style={{ ...globalStyles.bigTitle, color: event?.design?.themeColor }}
      >
        {t('event-at-glance')}
      </Text>
      <View style={globalStyles.lineBar} />

      <Text style={globalStyles.regularText}>
        {t('event-at-glance-pdf-text')}
      </Text>

      <View style={styles.itemsWrapper}>
        {eventStatisticsItems?.map(item => (
          <View style={styles.eventStatisticsItem} key={item.title}>
            <Text style={stylesAwesome.icon}>{'\uf6ff'}</Text>
            <View style={styles.textWrapper}>
              <Text style={styles.boldText}>{item.title}</Text>
              <Text style={styles.regularText}>{item.description}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default EventAtGlance;
